/* ==========================================================================
   Namo Narayana — Cart Drawer behaviours
   · discount / coupon code apply + remove
   · quick-add from recommendation rails
   · expandable price breakdown
   · rotating promo strip
   Delegated listeners on document so everything survives the drawer being
   re-rendered by cart.js / cart-drawer.js section refreshes.
   ========================================================================== */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var GHEE_GIFT_PROPERTY = '_nn_ghee_gift_offer';
  var GHEE_GIFT_OFFERS = [
    {
      gheeVariantId: '55812012572840',
      offerId: 'ghee-1l',
      gifts: [{ variantId: '67639580885160', quantity: 1 }],
    },
    {
      gheeVariantId: '55811997728936',
      offerId: 'ghee-2-5l',
      gifts: [
        { variantId: '67639580885160', quantity: 1 },
        { variantId: '67639651795112', quantity: 1 },
        { variantId: '67639655661736', quantity: 1 },
      ],
    },
    {
      gheeVariantId: '55812002971816',
      offerId: 'ghee-5l',
      gifts: [
        { variantId: '67639630856360', quantity: 1 },
        { variantId: '67639655661736', quantity: 1 },
        { variantId: '67639656841384', quantity: 1 },
      ],
    },
  ];

  function captureDrawerPosition(drawerInner, excludedLineKey) {
    var body = drawerInner.querySelector('.nnc-body');
    if (!body) return null;

    var bodyBounds = body.getBoundingClientRect();
    var visibleItem = Array.prototype.find.call(body.querySelectorAll('.nnc-item'), function (item) {
      var bounds = item.getBoundingClientRect();
      return (
        item.dataset.lineKey !== excludedLineKey &&
        bounds.bottom > bodyBounds.top &&
        bounds.top < bodyBounds.bottom
      );
    });
    var activeItem = document.activeElement && document.activeElement.closest('.nnc-item');

    return {
      scrollTop: body.scrollTop,
      lineKey: visibleItem && visibleItem.dataset.lineKey,
      itemTop: visibleItem ? visibleItem.getBoundingClientRect().top - bodyBounds.top : null,
      focusedLineKey: activeItem && activeItem.dataset.lineKey,
      focusedName: document.activeElement && document.activeElement.getAttribute('name'),
      focusedLabel: document.activeElement && document.activeElement.getAttribute('aria-label'),
      focusedTag: document.activeElement && document.activeElement.tagName,
    };
  }

  function restoreDrawerPosition(drawerInner, position) {
    if (!position) return;
    var body = drawerInner.querySelector('.nnc-body');
    if (!body) return;

    var bodyBounds = body.getBoundingClientRect();
    var items = body.querySelectorAll('.nnc-item');
    var anchor = Array.prototype.find.call(items, function (item) {
      return item.dataset.lineKey === position.lineKey;
    });
    if (anchor && position.itemTop !== null) {
      body.scrollTop += anchor.getBoundingClientRect().top - bodyBounds.top - position.itemTop;
    } else {
      body.scrollTop = position.scrollTop;
    }

    if (!position.focusedLineKey || !position.focusedTag) return;
    var focusedItem = Array.prototype.find.call(items, function (item) {
      return item.dataset.lineKey === position.focusedLineKey;
    });
    if (!focusedItem) return;
    var controls = focusedItem.querySelectorAll(position.focusedTag.toLowerCase());
    var focusTarget = Array.prototype.find.call(controls, function (control) {
      return (
        (position.focusedName && control.getAttribute('name') === position.focusedName) ||
        (position.focusedLabel && control.getAttribute('aria-label') === position.focusedLabel)
      );
    });
    if (focusTarget) {
      var drawer = drawerInner.closest('cart-drawer');
      if (drawer) trapFocus(drawer, focusTarget, { preventScroll: true });
      else focusTarget.focus({ preventScroll: true });
    }
  }

  function renderDrawerInner(source, target) {
    var position = captureDrawerPosition(target);
    target.innerHTML = source.innerHTML;
    rehydrate(true);
    restoreDrawerPosition(target, position);
  }

  function arrangeGheeGiftItems(position) {
    var list = document.querySelector('#CartDrawer .nnc-items');
    if (!list) return;
    var drawerInner = list.closest('.drawer__inner');
    position = position || (drawerInner && captureDrawerPosition(drawerInner));

    var items = Array.prototype.slice.call(list.querySelectorAll('.nnc-item'));
    var giftsByOffer = {};
    var orderedItems = [];

    items.forEach(function (item) {
      var offerId = item.dataset.giftOffer;
      if (!offerId) return;
      giftsByOffer[offerId] = giftsByOffer[offerId] || [];
      giftsByOffer[offerId].push(item);
    });

    items.forEach(function (item) {
      if (item.dataset.giftOffer) return;
      orderedItems.push(item);
      var offer = GHEE_GIFT_OFFERS.find(function (candidate) {
        return candidate.gheeVariantId === item.dataset.variantId;
      });
      if (offer && giftsByOffer[offer.offerId]) {
        orderedItems = orderedItems.concat(giftsByOffer[offer.offerId]);
        delete giftsByOffer[offer.offerId];
      }
    });

    Object.keys(giftsByOffer).forEach(function (offerId) {
      orderedItems = orderedItems.concat(giftsByOffer[offerId]);
    });

    if (
      items.length === orderedItems.length &&
      items.every(function (item, index) {
        return item === orderedItems[index];
      })
    ) {
      if (drawerInner) restoreDrawerPosition(drawerInner, position);
      return;
    }

    for (var index = orderedItems.length - 1; index >= 0; index -= 1) {
      var item = orderedItems[index];
      var currentItem = list.children[index];
      if (currentItem !== item) list.insertBefore(item, currentItem || null);
    }
    if (drawerInner) restoreDrawerPosition(drawerInner, position);
  }

  function money(cents) {
    if (window.Shopify && window.Shopify.formatMoney && window.nnCartMoneyFormat) {
      return window.Shopify.formatMoney(cents, window.nnCartMoneyFormat);
    }
    return '₹' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  /* ---------- re-render the drawer from the server ---------- */
  function refreshDrawer() {
    return fetch(ROOT + 'cart.js?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Could not refresh the cart drawer.');
        return response.json();
      })
      .then(function (cart) {
        var sections = cart.sections || {};
        var drawer = document.querySelector('cart-drawer');
        var drawerHtml = sections['cart-drawer'];
        var drawerRendered = !drawer;
        if (drawer && drawerHtml) {
          var drawerDoc = new DOMParser().parseFromString(drawerHtml, 'text/html');
          var source = drawerDoc.querySelector('.drawer__inner');
          var target = drawer.querySelector('.drawer__inner');
          if (source && target) {
            renderDrawerInner(source, target);
            drawer.classList.toggle('is-empty', !drawerDoc.querySelector('.nnc-item'));
            drawerRendered = true;
          }
        }

        var bubble = document.getElementById('cart-icon-bubble');
        var bubbleHtml = sections['cart-icon-bubble'];
        var bubbleRendered = !bubble;
        if (bubble && bubbleHtml) {
          var bubbleDoc = new DOMParser().parseFromString(bubbleHtml, 'text/html');
          var bubbleSource = bubbleDoc.querySelector('.shopify-section');
          if (bubbleSource) {
            bubble.innerHTML = bubbleSource.innerHTML;
            bubbleRendered = true;
          }
        }

        if (drawerRendered && bubbleRendered) return cart;
        return fetch(ROOT + '?section_id=cart-drawer', { credentials: 'same-origin' })
          .then(function (response) {
            if (!response.ok) throw new Error('Could not refresh the cart drawer.');
            return response.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var source = doc.querySelector('.drawer__inner');
            var target = document.querySelector('#CartDrawer .drawer__inner');
            if (source && target) renderDrawerInner(source, target);
            if (drawer) drawer.classList.toggle('is-empty', !doc.querySelector('.nnc-item'));
          })
          .then(refreshCartBubble)
          .then(function () {
            return cart;
          });
      });
  }

  function refreshCartBubble() {
    return fetch(ROOT + '?section_id=cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var src = doc.querySelector('.shopify-section');
        var dest = document.getElementById('cart-icon-bubble');
        if (src && dest) dest.innerHTML = src.innerHTML;
      })
      .catch(function () {});
  }

  function refreshCartPage() {
    var cartItems = document.querySelector('#main-cart-items .js-contents');
    if (!cartItems) return Promise.resolve();
    var scrollPosition = window.scrollY;
    var sectionId = document.getElementById('main-cart-items').dataset.id;
    if (!sectionId) return Promise.reject(new Error('Could not identify the cart page section.'));

    return fetch(ROOT + 'cart?section_id=' + encodeURIComponent(sectionId), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Could not refresh the cart page after gift sync.');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var updatedItems = doc.querySelector('#main-cart-items .js-contents');
        if (!updatedItems) throw new Error('The refreshed cart page did not contain cart items.');
        cartItems.innerHTML = updatedItems.innerHTML;
        window.scrollTo(0, scrollPosition);
      });
  }

  function openDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function' && !drawer.classList.contains('active')) drawer.open();
  }

  function getCart() {
    return fetch(ROOT + 'cart.js', { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error('Could not load cart for gift offer.');
      return response.json();
    });
  }

  function updateGheeGiftLines(cart, offers) {
    var updates = {};
    var changed = false;
    var additions = [];

    offers.forEach(function (offer) {
      var eligibleQuantity = cart.items.reduce(function (total, item) {
        return total + (String(item.variant_id) === offer.gheeVariantId ? item.quantity : 0);
      }, 0);

      offer.gifts.forEach(function (gift) {
        var giftLines = [];
        var giftQuantity = 0;
        cart.items.forEach(function (item) {
          if (
            String(item.variant_id) === gift.variantId &&
            item.properties &&
            item.properties[GHEE_GIFT_PROPERTY] === offer.offerId
          ) {
            giftLines.push({ item: item });
            giftQuantity += item.quantity;
          }
        });

        var targetQuantity = eligibleQuantity * gift.quantity;
        if (giftQuantity < targetQuantity) {
          additions.push({
            id: Number(gift.variantId),
            quantity: targetQuantity - giftQuantity,
            properties: { [GHEE_GIFT_PROPERTY]: offer.offerId },
          });
        } else if (giftQuantity > targetQuantity) {
          var remaining = targetQuantity;
          giftLines.forEach(function (line) {
            var nextQuantity = Math.min(line.item.quantity, remaining);
            remaining -= nextQuantity;
            if (line.item.quantity !== nextQuantity) {
              updates[line.item.key] = nextQuantity;
              changed = true;
            }
          });
        }
      });
    });

    return { updates: changed ? updates : null, additions: additions };
  }

  function updateGiftQuantities(updates) {
    return fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates }),
    }).then(function (response) {
      return response.json().then(function (cart) {
        if (!response.ok || cart.status || cart.errors) {
          throw new Error(cart.description || cart.errors || 'Could not update the gift quantities.');
        }
        return cart;
      });
    });
  }

  function addGheeGifts(gifts) {
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: gifts }),
    }).then(function (response) {
      return response.json().then(function (result) {
        if (!response.ok || result.status) {
          throw new Error(result.description || 'Could not add the ghee gift items.');
        }
        return result;
      });
    });
  }

  function reconcileGheeGifts() {
    var pendingSync = window.nnGheeGiftSyncPromise;
    if (pendingSync) {
      return pendingSync.then(function () {
        return reconcileGheeGifts();
      });
    }

    var operation = getCart().then(function (cart) {
      if (!cart || !Array.isArray(cart.items)) {
        throw new Error('Cart data was unavailable for the ghee gift sync.');
      }
      var plan = updateGheeGiftLines(cart, GHEE_GIFT_OFFERS);
      var changed = Boolean(plan.updates || plan.additions.length);
      if (!changed) return false;

      var didMutate = false;
      var updatePromise = plan.updates
        ? updateGiftQuantities(plan.updates).then(function () {
            didMutate = true;
          })
        : Promise.resolve();

      return updatePromise
        .then(function () {
          if (!plan.additions.length) return;
          return addGheeGifts(plan.additions).then(function () {
            didMutate = true;
          });
        })
        .then(function () {
          return true;
        })
        .catch(function (error) {
          if (didMutate) error.cartWasUpdated = true;
          throw error;
        });
    });

    var lockedOperation = operation.finally(function () {
      if (window.nnGheeGiftSyncPromise === lockedOperation) {
        window.nnGheeGiftSyncPromise = null;
      }
    });
    window.nnGheeGiftSyncPromise = lockedOperation;
    return lockedOperation;
  }

  var giftSyncTimer = null;
  var giftSyncPromise = null;
  var giftSyncPending = false;
  function scheduleGiftSync() {
    clearTimeout(giftSyncTimer);
    giftSyncTimer = setTimeout(function () {
      if (giftSyncPromise) {
        giftSyncPending = true;
        return;
      }
      giftSyncPromise = reconcileGheeGifts()
        .then(function (changed) {
          if (!changed) return;
          return Promise.all([refreshDrawer(), refreshCartPage()]).then(function (results) {
            if (window.NNCart && typeof window.NNCart.refresh === 'function') {
              return window.NNCart.refresh(results[0]);
            }
          });
        })
        .catch(function (error) {
          console.error('Could not sync the ghee gift offers.', error);
          if (error.cartWasUpdated) {
            return Promise.all([refreshDrawer(), refreshCartPage()]).then(function (results) {
              if (window.NNCart && typeof window.NNCart.refresh === 'function') {
                return window.NNCart.refresh(results[0]);
              }
            });
          }
        })
        .finally(function () {
          giftSyncPromise = null;
          if (giftSyncPending) {
            giftSyncPending = false;
            scheduleGiftSync();
          }
        });
    }, 50);
  }

  /* ---------- discount codes ----------
     /cart/update.js takes a `discount` parameter (Cart AJAX API, May 2025).
     Shopify prices the discount itself and returns the real cart, so the drawer
     shows the actual saving — whatever amount or percentage is configured in
     the admin — and it carries through to checkout on its own.

     Pass '' to remove. The response always returns 200: a code that doesn't
     apply comes back in `discount_codes` with `applicable: false`. */
  function setDiscount(code) {
    return fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: code || '' }),
    }).then(function (r) {
      return r.json();
    });
  }

  function discountIsApplied(cart, code) {
    if (!cart) return false;
    var wanted = String(code || '').toUpperCase();
    var codes = cart.discount_codes || [];
    for (var i = 0; i < codes.length; i++) {
      if (String(codes[i].code || '').toUpperCase() === wanted) return codes[i].applicable === true;
    }
    return false;
  }

  function setMsg(wrap, text, kind) {
    var msg = wrap.querySelector('.nnc-coupon__msg');
    if (!msg) return;
    msg.textContent = text || '';
    msg.className = 'nnc-coupon__msg' + (kind ? ' nnc-coupon__msg--' + kind : '');
  }

  function handleApply(wrap, codeFromChip) {
    var input = wrap.querySelector('.nnc-coupon__input');
    var btn = wrap.querySelector('.nnc-coupon__apply');
    var code = (codeFromChip || (input && input.value) || '').trim();

    if (!code) {
      setMsg(wrap, 'Please enter a coupon code.', 'err');
      if (input) input.focus();
      return;
    }
    if (btn) {
      btn.disabled = true;
      btn.dataset.label = btn.textContent;
      btn.textContent = 'Applying…';
    }
    setMsg(wrap, '', '');

    setDiscount(code)
      .then(function (cart) {
        if (discountIsApplied(cart, code)) return refreshDrawer();
        // Clear the rejected code so it doesn't linger on the cart.
        return setDiscount('').then(function () {
          setMsg(wrap, 'This code isn’t valid for the items in your cart.', 'err');
        });
      })
      .catch(function () {
        setMsg(wrap, 'Could not apply the code. Please try again.', 'err');
      })
      .finally(function () {
        if (btn && document.body.contains(btn)) {
          btn.disabled = false;
          btn.textContent = btn.dataset.label || 'Apply';
        }
      });
  }

  function handleRemove(wrap) {
    var btn = wrap.querySelector('.nnc-coupon__remove');
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Removing…';
    }
    setDiscount('')
      .then(refreshDrawer)
      .catch(function () {
        if (btn && document.body.contains(btn)) {
          btn.disabled = false;
          btn.textContent = 'Remove';
        }
      });
  }

  /* ---------- recommendation rails ----------
     The rail's Add buttons carry data-variant-id, so nn-sticky-cart.liquid's
     NNCart owns them: it adds to cart and swaps itself for a qty stepper, same
     as everywhere else on the site. We only have to (re)bind after a render. */
  function bindRecoButtons() {
    var drawer = document.getElementById('CartDrawer');
    if (drawer && window.NNCart && typeof window.NNCart.initButtons === 'function') {
      window.NNCart.initButtons(drawer);
      window.NNCart.refresh();
    }
  }

  /* ---------- delivery estimate by PIN code ----------
     Talks to the Vercel proxy (api/serviceability), which wraps Shiprocket.
     The PIN code is remembered so a returning shopper doesn't retype it. */
  var ETA_KEY = 'nnDeliveryPincode';

  function etaSay(wrap, html, kind) {
    var out = wrap.querySelector('[data-nn-eta-result]');
    if (!out) return;
    out.innerHTML = html || '';
    out.className = 'nnc-eta__result' + (kind ? ' nnc-eta__result--' + kind : '');
  }

  function etaPlural(n, word) {
    return n + ' ' + word + (n === 1 ? '' : 's');
  }

  function checkPincode(wrap, pincode) {
    var input = wrap.querySelector('[data-nn-eta-input]');
    var btn = wrap.querySelector('[data-nn-eta-check]');
    var code = String(pincode || (input && input.value) || '').trim();

    if (!/^\d{6}$/.test(code)) {
      etaSay(wrap, 'Please enter a valid 6-digit PIN code.', 'err');
      if (input) input.focus();
      return;
    }
    if (btn) btn.disabled = true;
    etaSay(wrap, 'Checking…', '');

    /* Shiprocket only knows the couriers wired into that account. We ship
       through others too, so a "not serviceable" answer — or the API being
       down — is not a reason to tell the shopper we can't deliver. Fall back
       to the configured flat estimate and only ever surface a real ETA when
       Shiprocket gives us one. */
    var fallbackDays = parseInt(wrap.getAttribute('data-fallback-days'), 10) || 3;
    function showFallback() {
      try {
        localStorage.setItem(ETA_KEY, code);
      } catch (e) {}
      etaSay(wrap, '<strong>Delivery in ' + etaPlural(fallbackDays, 'day') + '</strong> · COD available', 'ok');
    }

    /* `v` busts any response a browser cached back when the API was briefly
       returning the wrong CORS header. Bump it if that ever happens again. */
    var api = (wrap.getAttribute('data-api') || '').replace(/\/$/, '');
    fetch(api + '/api/serviceability?pincode=' + encodeURIComponent(code) + '&v=2', {
      mode: 'cors',
      cache: 'no-store',
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (d) {
        if (!d || d.error || !d.serviceable || !d.eta_days) return showFallback();

        try {
          localStorage.setItem(ETA_KEY, code);
        } catch (e) {}

        var where = [d.city, d.state].filter(Boolean).join(', ');
        var html = '<strong>Delivery in ' + etaPlural(d.eta_days, 'day') + '</strong>';
        if (where) html += ' to ' + where;
        html += d.cod_available ? ' · COD available' : ' · Prepaid only';
        etaSay(wrap, html, 'ok');
      })
      .catch(showFallback)
      .finally(function () {
        if (btn && document.body.contains(btn)) btn.disabled = false;
      });
  }

  function restorePincode() {
    var wrap = document.querySelector('[data-nn-eta]');
    if (!wrap) return;
    var saved;
    try {
      saved = localStorage.getItem(ETA_KEY);
    } catch (e) {}
    if (!/^\d{6}$/.test(saved || '')) return;
    var input = wrap.querySelector('[data-nn-eta-input]');
    if (input) input.value = saved;
    checkPincode(wrap, saved);
  }

  /* ---------- rotating promo strip ---------- */
  var stripTimer = null;
  function startStrip() {
    if (stripTimer) clearInterval(stripTimer);
    var strip = document.querySelector('.nnc-strip');
    if (!strip) return;
    var items = strip.querySelectorAll('.nnc-strip__item');
    if (items.length < 2) return;
    var i = 0;
    stripTimer = setInterval(function () {
      if (!document.body.contains(strip)) {
        clearInterval(stripTimer);
        stripTimer = null;
        return;
      }
      items[i].classList.remove('is-on');
      i = (i + 1) % items.length;
      items[i].classList.add('is-on');
    }, 4000);
  }

  /* ---------- delegated events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    var apply = t.closest && t.closest('.nnc-coupon__apply');
    if (apply) {
      e.preventDefault();
      handleApply(apply.closest('.nnc-coupon'));
      return;
    }

    var chip = t.closest && t.closest('.nnc-coupon__chip');
    if (chip) {
      e.preventDefault();
      var wrap = chip.closest('.nnc-coupon');
      var input = wrap.querySelector('.nnc-coupon__input');
      if (input) input.value = chip.dataset.code || chip.textContent.trim();
      handleApply(wrap, chip.dataset.code || chip.textContent.trim());
      return;
    }

    var remove = t.closest && t.closest('.nnc-coupon__remove');
    if (remove) {
      e.preventDefault();
      handleRemove(remove.closest('.nnc-coupon'));
      return;
    }

    var etaBtn = t.closest && t.closest('[data-nn-eta-check]');
    if (etaBtn) {
      e.preventDefault();
      checkPincode(etaBtn.closest('[data-nn-eta]'));
      return;
    }

    var toggle = t.closest && t.closest('.nnc-foot__totalbtn');
    if (toggle) {
      e.preventDefault();
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      var panel = document.getElementById(toggle.getAttribute('aria-controls'));
      if (panel) panel.classList.toggle('is-open', !open);
    }
  });

  function hasOrphanedGheeGift(cart) {
    return cart.items.some(function (item) {
      var offerId = item.properties && item.properties[GHEE_GIFT_PROPERTY];
      if (!offerId) return false;
      var offer = GHEE_GIFT_OFFERS.find(function (candidate) {
        return candidate.offerId === offerId;
      });
      return !offer || !cart.items.some(function (cartItem) {
        return String(cartItem.variant_id) === offer.gheeVariantId && cartItem.quantity > 0;
      });
    });
  }

  var checkoutValidationPending = false;
  var checkoutValidationBypass = false;
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.id !== 'CartDrawer-Form') return;
    if (checkoutValidationBypass) {
      checkoutValidationBypass = false;
      return;
    }
    event.preventDefault();
    if (checkoutValidationPending) return;

    var submitter = event.submitter || document.getElementById('CartDrawer-Checkout');
    var showCheckoutError = function (message) {
      var errors = document.getElementById('CartDrawer-CartErrors');
      if (errors) errors.textContent = message;
    };
    showCheckoutError('');
    checkoutValidationPending = true;
    var wasDisabled = submitter && submitter.disabled;
    if (submitter) submitter.disabled = true;

    getCart()
      .then(function (cart) {
        var hadOrphanedGift = hasOrphanedGheeGift(cart);
        return reconcileGheeGifts().then(function () {
          return getCart().then(function (updatedCart) {
            return {
              cart: updatedCart,
              hadOrphanedGift: hadOrphanedGift,
            };
          });
        });
      })
      .then(function (result) {
        var hasPaidProduct = result.cart.items.some(function (item) {
          return !(item.properties && item.properties[GHEE_GIFT_PROPERTY]);
        });
        if (result.hadOrphanedGift || hasOrphanedGheeGift(result.cart) || !hasPaidProduct) {
          return refreshDrawer().then(function () {
            showCheckoutError(
              'The free gift was removed because its qualifying product is no longer in your cart. Add a product before continuing.'
            );
          });
        }

        var code = submitter && submitter.getAttribute('data-nn-discount');
        if (code) {
          window.location.href = ROOT + 'checkout?discount=' + encodeURIComponent(code);
          return;
        }

        checkoutValidationBypass = true;
        checkoutValidationPending = false;
        if (submitter) submitter.disabled = wasDisabled;
        if (typeof form.requestSubmit === 'function') {
          if (submitter) form.requestSubmit(submitter);
          else form.requestSubmit();
        } else {
          checkoutValidationBypass = false;
          showCheckoutError('Your cart could not be verified. Please refresh and try again.');
        }
      })
      .catch(function (error) {
        checkoutValidationBypass = false;
        console.error('Could not verify the cart before checkout.', error);
        showCheckoutError('Your cart could not be verified. Please refresh and try again.');
      })
      .finally(function () {
        checkoutValidationPending = false;
        if (submitter) submitter.disabled = wasDisabled;
      });
  }, true);

  /* Any [data-nn-open-cart] link opens the drawer instead of /cart. The header
     icon is handled by cart-drawer.js itself (it binds #cart-icon-bubble). */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-nn-open-cart]');
    if (!link) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return;
    e.preventDefault();
    drawer.open(link);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var coupon = e.target.closest && e.target.closest('.nnc-coupon__input');
    if (coupon) {
      e.preventDefault();
      handleApply(coupon.closest('.nnc-coupon'));
      return;
    }
    var eta = e.target.closest && e.target.closest('[data-nn-eta-input]');
    if (eta) {
      e.preventDefault();
      checkPincode(eta.closest('[data-nn-eta]'));
    }
  });

  /* digits only in the PIN code box */
  document.addEventListener('input', function (e) {
    var eta = e.target.closest && e.target.closest('[data-nn-eta-input]');
    if (!eta) return;
    var clean = eta.value.replace(/\D/g, '').slice(0, 6);
    if (clean !== eta.value) eta.value = clean;
  });

  /* qty stepper: keep the native quantity-input contract cart.js listens for */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.nnc-qty button');
    if (!btn) return;
    e.preventDefault();
    var input = btn.parentElement.querySelector('input');
    if (!input) return;
    var step = parseInt(input.step, 10) || 1;
    var value = parseInt(input.value, 10) || 0;
    var min = Math.max(1, parseInt(input.min, 10) || 1);
    var max = input.max ? parseInt(input.max, 10) : Infinity;
    var next = btn.name === 'plus' ? value + step : value - step;
    if (next < min) next = min;
    if (next > max) next = max;
    if (next === value) return;
    input.value = next;
    var cartItems = btn.closest('cart-items, cart-drawer-items');
    if (cartItems && typeof cartItems.updateQuantity === 'function') {
      cartItems.updateQuantity(
        input.dataset.index,
        next,
        e,
        btn.name,
        input.dataset.quantityVariantId
      );
    } else {
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  /* ---------- keep drawer / sticky bar / bubble in sync ----------
     Dawn's pub-sub refreshes native cart actions. NNCart's custom DOM events
     still need a drawer refresh when their callers haven't rendered sections. */
  var syncTimer = null;
  function scheduleSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      refreshDrawer();
    }, 250);
  }

  document.addEventListener('cart:updated', function (event) {
    scheduleGiftSync(event.detail && event.detail.cartData);
    if (event.detail && (event.detail.source === 'nn-sticky-cart-add' || event.detail.sectionsRendered)) return;
    scheduleSync();
  });
  document.addEventListener('nn:cart:updated', function (event) {
    scheduleGiftSync(event.detail && event.detail.cartData);
    if (!event.detail || !event.detail.sectionsRendered) scheduleSync();
  });
  document.addEventListener('cart:refresh', function () {
    scheduleGiftSync();
    scheduleSync();
  });

  function subscribeToDawn() {
    if (typeof window.subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;
    window.subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'nn-cart-drawer') return;
      var cartSnapshot = event && event.cartData;
      if (event && event.source === 'product-form') {
        cartSnapshot =
          typeof CartItems !== 'undefined' && typeof CartItems.fetchCartData === 'function'
            ? CartItems.fetchCartData()
            : null;
      }
      scheduleGiftSync(cartSnapshot);
      // Dawn's CartItems subscriber already refreshes the drawer for this event.
    });
    return true;
  }
  if (!subscribeToDawn()) {
    document.addEventListener('DOMContentLoaded', subscribeToDawn);
  }

  /* Everything that has to run after the drawer's markup is (re)built.
     Exposed so callers that render the drawer themselves — the PDP buy box
     injects it straight from the /cart/add.js sections payload — get the same
     wiring without re-fetching the section. */
  function rehydrate(skipGiftSync) {
    startStrip();
    bindRecoButtons();
    restorePincode();
    arrangeGheeGiftItems();
    if (!skipGiftSync && !giftSyncPromise) scheduleGiftSync();

    if (!skipGiftSync) scheduleGiftSync();
  }

  document.addEventListener('DOMContentLoaded', rehydrate);
  document.addEventListener('DOMContentLoaded', scheduleGiftSync);
  document.addEventListener('shopify:section:load', rehydrate);
  if (document.readyState !== 'loading') rehydrate();

  window.nnCartDrawer = {
    refresh: refreshDrawer,
    open: openDrawer,
    startStrip: startStrip,
    rehydrate: rehydrate,
    arrangeGheeGiftItems: arrangeGheeGiftItems,
    capturePosition: captureDrawerPosition,
    syncGifts: scheduleGiftSync,
    renderSection: renderDrawerInner,
  };
})();